var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SamSelect',{staticClass:"w-100",class:{'sidebar-style': _vm.sidebarStyle},attrs:{"model":_vm.selected,"label":"name","options":_vm.allStores,"clearable":false,"searchable":true},on:{"select":_vm.selectStore}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }